import React, { useState, useContext, useEffect, useRef } from 'react';
import AuthHeader from '../../commons/AuthHeader';
import AuthFooter from '../../commons/AuthFooter';
import { Button, ButtonVariant, IconName, ButtonIconAlign } from '@eightfold.ai/octuple';
import { actionButtonStyle} from '../../commons/commonStyles';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { globalContext } from '../../store';
import Api from '../../Api';
import { initialiseImmersiveAssessment } from '../../commons/commonFunctions';
import Loader from '../../commons/Loader';

const ImmersiveVideo = () => {
  const navigate = useNavigate();
  const { globalState, dispatch } = useContext(globalContext);
  const title = globalState?.clientData?.name;
  const immersiveAssessmentData = globalState?.immersiveAssessmentData;
  const [, setLeaderName] = useState<any>('');
  const [headerLogo, setHeaderLogo] = useState<string>('');
  const [, setHeaderImage] = useState<string>('');
  const [, setPrimaryColor] = useState<string>('#BA3A19');
  const [showLoader, setShowLoader] = useState(true);
  const isBtnDisabled = immersiveAssessmentData?.assessmentStatus === 'N' && (immersiveAssessmentData?.prepWorkCompleted === false || immersiveAssessmentData?.prepWorkCompleted === undefined);
  const [disableContinueBtn, setDisableContinueBtn] = useState(isBtnDisabled ? true : false);
  const [playing, setPlaying] = useState(false);
  const [videoURL, setVideoURL] = useState<string>('');
  const playerRef = useRef<any>(null);
  const prepData = globalState?.immersiveAssessmentData?.prepData;
  
  useEffect(() => {
    const params = {globalState, dispatch, navigate, setLeaderName, setHeaderImage, setHeaderLogo, setPrimaryColor, title};
    initialiseImmersiveAssessment(params);
    Api.getVideoURL(prepData?.videoAssetPath)
      .then(response => {
        if (response?.success) {
          setVideoURL(response?.response?.data?.signedUrl);
        } else {
          setShowLoader(false);
        }
      })
      .catch((err: any) => {
        setShowLoader(false);
        console.log('Error fetching video URL:', err);
      });
  }, []);

	const handleEnded = () => {
    setDisableContinueBtn(false);
    setPlaying(false);
  };

  const handleSeek = (seconds:any) => {
    if (seconds.target.duration - seconds.target.currentTime <= 1) {
      handleEnded();
    }
  };

  const handleReady = () => {
    setTimeout(() => {
      if (playerRef?.current) {
        playerRef.current.style.display = 'block';
      }
      setTimeout(() => {
        setShowLoader(false);
      }, 1000);
    }, 3000);
  }

  return (
    <>
      {showLoader && <Loader />}
      <div className='mainWrapper'>
        <div className='innerWrapper'>
          <AuthHeader title={title} headerLogo={headerLogo} setLoader={setShowLoader} />
          <div className='middleWrapper'>
            <div className='leftTextWrapper'>
              <div>
                <Button
                  text={`Back to Immersive ${prepData?.assessmentType} Welcome`}
                  variant={ButtonVariant.SystemUI}
                  classNames='backButton'
                  onClick={() => navigate('/immersive/introduction')}
                  transparent={true}
                  iconProps={{ path: IconName.mdiChevronLeft,  }}
                />
              </div>
              <div className='textContainer'>
                <h2 className='textHeading' style={{marginBottom:'20px'}}>Watch the introduction video</h2>
                {/* <h2 className='textDescription'>We're excited to invite you to participate in the Heidrick & Struggles Immersive Agility Assessment. Before you begin, we want to help you understand what to expect from this unique and engaging experience. </h2> */}
                  <Button
                    text='Continue'
                    variant={ButtonVariant.Secondary}
                    classNames={disableContinueBtn ? 'actionButton inactive' :'actionButton'}
                    style={actionButtonStyle}
                    onClick={() => {
                      navigate('/immersive/downloadPDF')
                    }}
                    iconProps={{path:IconName.mdiArrowRight}}
                    alignIcon={ButtonIconAlign.Right}
                    disabled={disableContinueBtn}
                  />
              </div>
            </div>

            <div className='rightTextWrapper'>
              <div className='bgImageWrapper' style={{backgroundImage: `url(./../assets/img/immersiveBackground.svg)`}}>
                {/* <img src= className='BGImage' alt="background-image"/> */}
                <div className='contentOverlay' style={{background: 'transparent'}}>
                  <ReactPlayer
                    ref={playerRef}
                    src={videoURL}
                    playing={playing}
                    controls={true}
                    style={{borderRadius:'24px', minWidth:'100%', minHeight: '100%', display: 'none'}}
                    width='100%'
                    height='100%'
                    onEnded={handleEnded}
                    pip={false}
                    onSeeking={handleSeek}
                    onReady={handleReady}
                  />
                </div>
              </div>
            </div>
          </div>
          <AuthFooter />
        </div>
      </div>
    </>
  );
};

export default ImmersiveVideo;
